import React from 'react';
import styled from 'styled-components';

import ChainExplorerLink from 'components/wallet/icons/explorer/ChainExplorerLink';
import { useIsMobile } from 'hooks/useIsMobile';
import { useDiscoverEip6961WalletByRdns } from 'lib/ethereum/walletDiscovery/walletDiscovery';
import { useSelector } from 'reduxState/store';

import { getWalletIcon } from '../icons/walletIcon';

const Title = styled.div`
  color: var(--gray4);
  text-align: center;
  font-weight: bold;
  padding-top: 24px;
  padding-bottom: 4px;
`;

const Address = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  .isMobileStyle & {
    flex-direction: column;
  }
`;

export default function ConnectedWallet() {
  const isMobile = useIsMobile();
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const walletType = useSelector(state => state.wallet.walletType);
  const walletDiscoveryRdns = useSelector(
    state => state.wallet.walletDiscoveryRdns
  );
  const discoveredWallet = useDiscoverEip6961WalletByRdns(
    walletDiscoveryRdns,
    true
  );
  if (!walletAddress || !walletType) {
    return null;
  }
  const walletIcon = (
    <img
      src={getWalletIcon(walletType, discoveredWallet?.info.icon)}
      style={{ height: 20 }}
      alt="Wallet"
    />
  );
  return (
    <>
      <Title>Connected Wallet</Title>
      <Wrap>
        {!isMobile && <>{walletIcon}&nbsp;&nbsp;</>}
        <Address>
          {isMobile && <>{walletIcon} </>}
          {walletAddress}
        </Address>
        &nbsp;&nbsp;
        <ChainExplorerLink address={walletAddress} />
      </Wrap>
    </>
  );
}
